export const MONTHS_SHORT = ["янв","фев","мар","апр","май","июн","июл","авг","сен","окт","ноя","дек"];

const _today = new Date();
_today.setHours(0, 0, 0, 0);
export const _todayTs = _today.getTime();

export function fmtNum(n: number, decimals = 0): string {
  const s = decimals > 0 ? n.toFixed(decimals) : Math.round(n).toString();
  return s.replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0");
}

export function fmtDate(ts: number): string {
  const d = new Date(ts);
  return `${d.getDate()} ${MONTHS_SHORT[d.getMonth()]}`;
}

/** Форматировщик создаём ОДИН раз.
 *  `toLocaleString` каждый вызов заново разбирает локаль и настройки; при
 *  тысячах ячеек это заметная доля открытия страницы. Готовый `Intl.NumberFormat`
 *  даёт тот же результат. */
const RUB_FORMAT = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 0 });
const NUMBER_FORMAT = new Intl.NumberFormat("ru-RU");

/** Same default rounding/grouping as number.toLocaleString("ru-RU"), without
 * constructing a formatter for every cell. Zero and fractional values stay intact. */
export function formatLocaleNumber(value: number): string {
  return NUMBER_FORMAT.format(value);
}

export function rub(v: number) {
  if (!v) return "—";
  return RUB_FORMAT.format(v) + " ₽";
}

/** Пустая ячейка таблицы: короткое тире «–», а не длинное — у Source Sans 3 длинное выглядит жирной чертой. */
export const EMPTY_CELL_MARK = "\u2013";
export const isEmptyCellMark = (text: string) => text === EMPTY_CELL_MARK || text === "—";

/**
 * Деньги в ячейке таблицы: целые рубли, разряды тонким пробелом, настоящий
 * минус, ноль и «нет данных» — короткое тире, знак «₽» справа через
 * неразрывный пробел. Ячейка с прочерком знака не получает: «– ₽» читалось бы
 * как «ноль рублей», а прочерк значит «нет данных». Единица повторяется и в
 * подписи колонки («Цена, ₽», getColLabel) — владелец попросил видеть её у
 * каждого числа (2026-09-18).
 */
export function rubCell(v: number | null | undefined): string {
  if (v == null || !Number.isFinite(v)) return EMPTY_CELL_MARK;
  const abs = Math.round(Math.abs(v));
  if (abs === 0) return EMPTY_CELL_MARK;
  const body = RUB_FORMAT.format(abs).replace(/\u00a0/g, "\u202f");
  return `${v < 0 ? "\u2212" : ""}${body}\u00a0₽`;
}

export function fmt(v: number | null | undefined, decimals = 0) {
  if (v == null || isNaN(v)) return "—";
  return fmtNum(v, decimals);
}

export function pct(v: number, dec = 1) {
  if (!v) return "—";
  return v.toLocaleString("ru-RU", { maximumFractionDigits: dec }) + "%";
}

export function parseNum(s: string | number | undefined): number {
  if (s == null) return 0;
  if (typeof s === "number") return s;
  return parseFloat(String(s).replace(/\s/g, "").replace(/\./g, "").replace(",", ".")) || 0;
}
